// -----------------------------------------------------------------------------
// ScanModal — Modal de scan de code-barres (html5-qrcode)
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { T } from "../i18n/translations";
import { getColors } from "../styles/theme";
import { Ic, ICONS } from "./Icons";

export default function ScanModal({
  lang,
  dark,
  scanContainerRef,
  onClose,
}) {
  const t = T[lang];
  const { textPrimary, textSecondary, borderColor } = getColors(dark);

  return (
    <div
      className="modal-bg"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div style={{ background:dark?"#0f0f1a":"#fff", border:`1px solid ${borderColor}`, borderRadius:18, padding:"22px", width:"100%", maxWidth:400 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
          <h2 style={{ fontSize:16, fontWeight:800, color:textPrimary }}>{t.scanBarcode}</h2>
          <button onClick={onClose} style={{ color:textSecondary, background:"none", border:"none", cursor:"pointer" }}>
            <Ic d={ICONS.close} size={18} />
          </button>
        </div>
        <div
          id="scan-container"
          ref={scanContainerRef}
          style={{ width:"100%", borderRadius:12, overflow:"hidden", background:"#000", minHeight:200 }}
        />
        <button
          onClick={onClose}
          style={{ width:"100%", marginTop:14, padding:"11px", borderRadius:10, background:"rgba(239,68,68,.1)", color:"#f87171", fontWeight:600, fontSize:14, border:"none", cursor:"pointer" }}
        >
          {t.stopScan}
        </button>
      </div>
    </div>
  );
}
